import * as _ from 'lodash';

/**
 * @typedef {{Id: string, ...}} IEntity
 * 
 * @callback IEntityPredicate
 * @param {IEntity} entity
 * @returns {boolean}
 */

export class EntityCollection {
    /**
     *
     * @param {IEntity[]} entities
     */
    constructor(entities) {
        this.list = entities;
    }

    /**
     * Finds the object with corresponding id
     * @param {string} id
     * @returns {IEntity}
     */
    find(id) {
        if (this._map == null) {
            this._map = _.keyBy(this.list, x => x.Id);
        }
        return this._map[id];
    }

    /**
     * Returns true if predicate returns true for any entity with id in ids.
     * If no entity with matching id is found, the id is ignored.
     * @param {any} ids
     * @param {IEntityPredicate} predicate
     */
    some(ids, predicate) {
        return _.some(ids, x => {
            let obj = this.find(x);
            return obj && predicate(obj);
        });
    }
}
